<template lang="pug">      
  nt-dialog(
    v-model='dialog'
    :title="$t('promotion')"
    max-width="1200"
    scrollable
  )
    div.promotion-container
      div(
        v-for='(item, i) in promotions'
        :key='i'
      )
        card-promotion(:item="item", :prePromotion="true").card-promotion
</template>
<script>
import CardPromotion from '@/components/Promotion/CardPromotion'

export default {
  components : {
    CardPromotion,
  },

  data: () => ({ 
    showRaw: false,
    dialog: false, 
    promotions: [], 
  }),

  methods : {
    open (promotions) {
      this.promotions = promotions
      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  }
}
</script>
<style scoped>
.promotion-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 20px;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 12px;
  padding-bottom: 12px;
  overflow-y: scroll;
  overflow-x: hidden;
}

@media only screen and (max-width: 799px) {
  .promotion-container {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media only screen and (max-width: 450px) {
  .card-promotion {
    width: calc(92vw - 25px)
  }
}

</style>